/**
 * SFN i18n — 日本語 (ja-JP). Overlays EN base with professional translations
 * for every REQUIRED_I18N_KEYS entry.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const ja: Dict = {
  ...en,

  // Navigation
  "nav.home": "ホーム",
  "nav.about": "概要",
  "nav.contact": "お問い合わせ",
  "nav.ecosystem": "エコシステム",
  "nav.tokens": "トークン",
  "nav.protection": "保護",
  "nav.secure": "確保する",
  "nav.faq": "よくある質問",
  "nav.connectWallet": "ウォレット接続",
  "nav.language": "言語",

  // Hero
  "hero.eyebrow": "Solana 上で検証済みの $1 インフレ保護",
  "hero.stat1": "確保済みの食事",
  "hero.stat2": "実物資産の裏付け",
  "hero.stat3": "平均決済速度",

  // Bento
  "bento.title": "サステナブル・フード&エコ・ネットワーク (SFN):仕組み",
  "bento.sub": "トークノミクス、実用性、そしてレジリエンスを、コース料理のように構成。",
  "bento.card1.title": "ビジョンとネットワーク (SFN)",
  "bento.card1.text":
    "SFN は認証済み提携キッチン、地元農家、支援者による開かれた分散型ネットワークです。コミュニティ資金とソーラー稼働の運営を結びつけ、食料生産コストを圧倒的に低く安定させます。",
  "bento.card2.title": "分散型リージョナル調達ハブ",
  "bento.card2.text":
    "私たちの旗艦拠点は、30 THB フレームワークを日々検証する現実のテストベッドです。ここから一括仕入れ、ソーラー稼働のキッチン設備、全提携店が受け継ぐ運営基準を統括します。",
  "bento.card3.title": "スケーラブルなグローバルインパクト",
  "bento.card3.text":
    "私たちは 1 店舗で止まりません。SFN は成長を前提に設計されています。海外の支援者はデジタルで食事をスポンサーでき、地域の食堂はネットワークに参加して補助食材とソーラー電力を活用できます。",

  // Pilot / Sandbox
  "pilot.eyebrow": "ライブ・パイロット実証：Thailand Sandbox",
  "pilot.title": "タイ:フェーズ 1 パイロット市場(サンドボックスゾーン)",
  "pilot.body":
    "効率的な地域市場で立ち上げることで、MEAL4/MEAL2 のトークノミクスと現実のサプライチェーンを最大限の運営管理下でストレステストできます。すべてのキッチン、食材の流れ、決済経路を封じ込めた環境で検証してから、SFN は国際展開を実行します。",
  "pilot.benchmark.label": "$1 グローバル基準",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc": "食事価格を 30 THB（$1）以下に固定し、ローカライズされた Web3 の仕組みでグローバルなスケーラビリティを証明します。",
  "pilot.phase1": "フェーズ 1：地域パイロット（$1 目標）",
  "pilot.phase2": "フェーズ 2:グローバル拡張",
  "pilot.phase.arrow": "ロードマップの流れ",
  "pilot.stat1.label": "パイロット市場",
  "pilot.stat1.value": "タイ · カオヨイ",
  "pilot.stat2.label": "食事アンカー",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "次のフェーズ",
  "pilot.stat3.value": "グローバル展開",

  // About
  "about.eyebrow": "創業者とミッション",
  "about.titleA": "その裏側にある",
  "about.titleB": "サステナブル・フード&エコ・ネットワーク",
  "about.body":
    "SFN は、ドイツ流の経営学とタイの現場ガストロノミーを橋渡しする起業家チームによって設立されました。世界的なインフレが地域社会に直撃する現場を目の当たりにし、私たちは投機ではなく人間の基本的な安定のためにブロックチェーンを活用することを決意しました。タイ・ペッチャブリー県のパイロットキッチンは、透明でソーラー駆動、分散型の食料安全保障の未来を示す運営ブループリントです。",

  // Contact
  "contact.eyebrow": "パートナーシップのご相談",
  "contact.titleA": "ネットワークに",
  "contact.titleB": "参加する",
  "contact.body":
    "MEAL トークンを受け入れたい地元キッチン、直接供給したい農家、質問のある海外支援者の方——ぜひご連絡ください。",
  "contact.name": "お名前",
  "contact.namePh": "お名前",
  "contact.email": "メール",
  "contact.emailPh": "you@example.com",
  "contact.subject": "件名",
  "contact.subjectPh": "パートナーシップ、供給、支援など",
  "contact.message": "メッセージ",
  "contact.messagePh": "プロジェクトやご質問についてお聞かせください……",
  "contact.sent": "メッセージを安全に送信しました",
  "contact.successBody":
    "暗号化されたエンドポイント経由でお届けしました。48 時間以内に担当者よりご連絡いたします。",
  "contact.errorTitle": "送信に失敗しました",
  "contact.errorBody": "メッセージを届けられませんでした。接続を確認して再度お試しください。",
  "contact.dismissOk": "もう一件送る",
  "contact.dismissError": "再試行",
  "contact.responseNote": "通常 48 時間以内にご返信いたします。",
  "contact.send": "メッセージを送信",

  // Dual-token
  "dual.eyebrow": "デュアルトークン・アーキテクチャ",
  "dual.title": "デュアルトークン方式:保護と実用性を両立",
  "dual.sub":
    "MEAL4 は価値を運び、MEAL2 は価値を静止させる。両者が揃って初めて食料保障は使える形になります。",
  "dual.meal4.t": "MEAL4 – インフレシールド",
  "dual.meal4.d":
    "総供給量は厳格に 100 万トークン、追加発行の余地は永久にありません。MEAL4 は実物資産準備と戦略的な大量購買力に裏付けられたデジタル契約として、食料生産コストを根源から凍結し、市場価格の上昇に対するデフレヘッジを形成します。",
  "dual.meal2.t": "MEAL2 – デイリーユーティリティ",
  "dual.meal2.d":
    "レストラン運営、リワード、コミュニティ支援を円滑にするための実用的な日常トークン。即時モバイル決済、地元ゲスト向けのロイヤルティ割引、世界の支援者による透明なデジタル食事スポンサーシップを可能にし、エコシステムを駆動します。",

  // Protection
  "protection.eyebrow": "改ざん不能なセキュリティ · オンチェーン",
  "protection.title": "コードに刻まれた撤回不能な信頼",
  "protection.sub":
    "スマートコントラクトに厳格なセキュリティパラメータを直接ハードコードし、インフレと不正変更からコミュニティを守ります。",
  "protection.f1.title": "100% フリーズ不可の資産",
  "protection.f1.text":
    "両トークンとも「フリーズ権限」は恒久的に放棄されています。いかなる中央権力・機関・開発者も、あなたのウォレットを凍結したり MEAL の利用を止めたりできません。",
  "protection.f2.title": "ハードコードされた供給上限 (MEAL4)",
  "protection.f2.text":
    "MEAL4 の「ミント権限」は不可逆的に破棄されています。100 万枚を超える発行は数学的に不可能で、食料保障のヘッジ価値は永久に希薄化から守られます。",
  "protection.f3.title": "柔軟なユーティリティ拡張 (MEAL2)",
  "protection.f3.text":
    "SFN に加わる新しい提携キッチンにシームレスに追随するため、MEAL2 のみ意図的にミント機能を残し、地域経済に十分な取引燃料を供給し続けます。",

  // Swap
  "swap.eyebrow": "トークンセール",
  "swap.title": "食事を確保する",
  "swap.sub":
    "MEAL4 に直接スワップ。1 トークンが提携キッチンでの 1 食を保証します——今日も、明日も、危機の後も。",
  "swap.connectWallet": "スワップするにはウォレット接続",
  "swap.meal4.milestoneLabel":
    "現在のマイルストーン：フェーズ1目標 — Thailand Sandbox セントラルキッチン基盤と初期エクスプレス展開",
  "swap.meal4.milestoneProgress": "調達済み {raised} / {goal} USDC",
  "swap.meal4.percent": "{pct}% 達成",
  "swap.meal4.treasuryLabel": "プロジェクト・トレジャリーウォレット",
  "swap.meal4.treasuryNote":
    "拠出金は SFN プロジェクトトレジャリーへ直接ルーティングされます——DEX 経由やオープンマーケットへの流出はありません。",
  "swap.meal4.tooltip":
    "トークン配布は実物在庫に裏付けられ、価格安定を確保するためマイルストーン式の資金調達で管理されています。",
  "swap.meal4.tooltipAria": "マイルストーン式資金調達の仕組み",
  "swap.meal2.rateLabel": "固定レート · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "支払い通貨",
  "swap.meal2.solRoute": "自動ルーティング：SOL → USD（Jupiter）→ MEAL2、1単位あたり1ドル",
  "swap.meal2.priceFallback": "参考価格（フィード停止中）",
  "swap.phantomApproving": "Phantom の承認を待っています……",

  // Trust
  "trust.eyebrow": "透明性と信頼",
  "trust.title": "触れられる実物に裏付けられた仕組み。",
  "trust.body":
    "エコシステムは実物資産に錨を下ろしています:タイの提携レストラン「the SFN Pilot Kitchen」、支援不動産、そして毎日実際に料理を提供する営業キッチン。地域と運営は開示しますが、スタッフとゲストの安全のため正確な住所は非公開としています。",

  // FAQ
  "faq.eyebrow": "よくある質問",
  "faq.title": "よくある質問",
  "faq.sub":
    "サステナブル・フード&エコ・ネットワーク (SFN) と食事安定化エコシステムについて知っておきたい全て。",
  "faq.q1": "インフレの中で $1 の健康的で高品質な食事をどう保証するのですか?",
  "faq.a1":
    "3 つの柱を組み合わせています:地元農家からの戦略的一括仕入れ、ソーラーインフラによるレストラン運営コスト削減、そして MEAL4 インフレシールドによるコミュニティ支援。これにより私たちの厨房の基本価格は市場インフレから完全に切り離されます。",
  "faq.q2": "トークンが拡大した場合、一つのレストランで需要をさばけますか?",
  "faq.a2":
    "その必要はありません。「the SFN Pilot Kitchen」は生きた実証拠点であり、上位アーキテクチャは SFN そのものです。需要拡大に応じて独立系のキッチンや食堂がネットワークに参加し、補助食材と設備を活用して 30 THB の約束を世界へスケールできます。",
  "faq.q3": "タイに住んでいない海外支援者はどう参加できますか?",
  "faq.a3":
    "海外支援者は MEAL2 トークンを購入し、デジタルの「食事スポンサー」を開始できます。スポンサートークンは透明に地域の社会支援プログラムへ配分され、高齢者・低所得世帯・脆弱層が認証 SFN キッチンで無料または 30 THB で食事できます。",
  "faq.q4": "MEAL4 は一般的な暗号資産と何が違うのですか?",
  "faq.a4":
    "MEAL4 は投機的トークンではなく、実物の食料備蓄と持続可能なガストロノミー基盤の拡張に裏付けられた実用的な契約です。ミント権限が恒久破棄されているため、食料安全保障のために数学的に上限が定まった価値貯蔵手段として機能します。",

  // Roadmap
  "roadmap.eyebrow": "実行 · 軌道",
  "roadmap.title": "工場フロアからグローバルプロトコルへ",
  "roadmap.sub":
    "現場での反復による 6 段階の歩み。すべてのマイルストーンはスライドではなく運営の現実に根ざしています。",
  "roadmap.card1.title": "工場労働者向け食料供給",
  "roadmap.card1.desc":
    "1 食 45 THB を超える食料インフレを目撃し、工場労働者と低所得層が健康的な栄養から締め出されていく現実を確認。",
  "roadmap.card2.title": "$1 フレームワーク構想",
  "roadmap.card2.desc":
    "安定した 30 THB マージンを目標とする経済フレームワークを設計——恒久的に手頃で高品質な食事の基礎。",
  "roadmap.card3.title": "サプライチェーン調達テスト",
  "roadmap.card3.desc":
    "農家直結の調達パイロットを実施し、単一店舗モデルの構造的限界を把握。分散型リージョナル調達ハブの必要性を定義。",
  "roadmap.card4.title": "多店舗展開とソーラーの起源",
  "roadmap.card4.desc":
    "複数店舗へ拡張し、一貫したエネルギーオーバーヘッドを検出。ソーラー基盤こそが欠落したコスト安定化レイヤーであると検証。",
  "roadmap.card5.title": "運営実証と $1 パイロット",
  "roadmap.card5.desc":
    "月内の中弛みなく販売が完全に安定——30 THB モデルはスケールで運営的に持続可能であると証明。",
  "roadmap.card6.title": "SFN トークン化と SolarPando スプリント",
  "roadmap.card6.desc":
    "SFN が Solana で正式ローンチ:MEAL4 と MEAL2 の起源、不可変性の検証、SolarPando インフラスプリントが同時稼働。",

  // Docs
  "docs.eyebrow": "ナレッジベース",
  "docs.title": "ホワイトペーパーと法的文書",
  "docs.sub": "公式 SFN ドキュメントと監査レポートをダウンロード。",
  "credits.line": "コンセプトとフレームワーク: Boy Khomkrit — 初版公開: 2021年7月4日",
  "credits.date": "原本作成日: 2021年7月4日 (04.07.2021)",
  "credits.version": "ホワイトペーパー v1.0 — 初版公開: 2021年7月4日",
  "docs.btn1": "SFN エコシステム・ホワイトペーパー (EN)",
  "docs.btn2": "エグゼクティブ・トークノミクスサマリー (DE)",
  "docs.btn3": "タイ・ガストロノミー法的フレームワーク",
  "docs.btn4": "暗号セキュリティ監査レポート",

  // Verify
  "verify.meal4.title": "MEAL4 — インフレシールド検証",
  "verify.meal4.sub": "改ざん不能な資産パラメータ",
  "verify.meal4.cta": "Solana Explorer で MEAL4 を表示",
  "verify.meal2.title": "MEAL2 — デイリーユーティリティ検証",
  "verify.meal2.sub": "柔軟なユーティリティパラメータ",
  "verify.meal2.cta": "Solana Explorer で MEAL2 を表示",
  "verify.item.meal4Supply.label": "MEAL4 供給上限を検証",
  "verify.item.meal4Supply.statusPassed": "合格 - 上限 1,000,000",
  "verify.item.meal4Supply.statusLive": "合格 - オンチェーン供給量:",
  "verify.item.meal4Mint.label": "MEAL4 ミント権限",
  "verify.item.meal4Mint.statusPassed": "合格 - 破棄済み(100 万ハードキャップ)",
  "verify.item.meal4Mint.statusActive": "アクティブ - ミント権限あり",
  "verify.item.meal4Freeze.label": "MEAL4 フリーズ権限",
  "verify.item.meal4Freeze.statusPassed": "合格 - 放棄済み(中央制御なし)",
  "verify.item.meal4Freeze.statusActive": "アクティブ - フリーズ権限あり",
  "verify.item.meal2Freeze.label": "MEAL2 フリーズ権限",
  "verify.item.meal2Freeze.statusPassed": "合格 - 放棄済み(流動性解放)",
  "verify.item.meal2Freeze.statusActive": "アクティブ - フリーズ権限あり",
  "verify.item.meal2Mint.label": "MEAL2 ミント権限",
  "verify.item.meal2Mint.statusRevoked": "放棄済み - 供給凍結",
  "verify.item.meal2Mint.statusActive": "アクティブ - SFN 成長プロトコル管理",
  "verify.item.meal2Supply.label": "MEAL2 流通供給量",
  "verify.item.meal2Supply.statusLive": "ライブ - ",
  "verify.badge.connecting": "接続中",
  "verify.badge.cached": "キャッシュ",
  "verify.badge.verified": "検証済み",
  "verify.networkBusy": "ネットワーク混雑、再接続中……(試行 ",

  // Transparency
  "transparency.jsonImmutable": "// 不変。変更不可。",
  "transparency.jsonCeiling": "// ハードコードされた上限。",

  // Connection
  "connection.eyebrow": "// 接続",
  "connection.step1.title": "一括仕入れ",
  "connection.step1.text":
    "MEAL4 準備金が地元農家からの大量直接調達を資金化し、食材コストを市場インフレ以下に固定。",
  "connection.step2.title": "ソーラーインフラ",
  "connection.step2.text":
    "オフグリッドのソーラーアレイが提携キッチンに 24 時間電力を供給し、各皿のコストからエネルギー変動を排除。",
  "connection.step3.title": "換金可能な食事",
  "connection.step3.text":
    "ゲストはスキャンして MEAL2 で支払い、1 USD 未満で温かく栄養ある一皿を受け取ります——デジタル契約が実際のテーブルで完結。",

  // Barometer
  "barometer.eyebrow": "ライブ · オンチェーン · 検証済み",
  "barometer.title.a": "実世界",
  "barometer.title.b": "在庫バロメーター",
  "barometer.sub":
    "すべての食事を支える実物準備を透明に可視化。数値はパイロットキッチンから更新されます——推測ではなく在庫。",
  "barometer.rice": "米の備蓄",
  "barometer.oil": "植物油",
  "barometer.solar": "ソーラー電力ステータス",

  // Footer
  "footer.tag":
    "SFN(サステナブル・フード&エコ・ネットワーク)と MealToken24 は、ブロックチェーン技術をインフレと世界的食料不安に対抗する武器にすることを使命としています。現実のキッチンが原動力、リアルな人々のために構築。",
  "footer.disclaimer":
    "免責事項:MEAL2 と MEAL4 は Sustainable Food & Eco Network ガストロノミー・エコシステム内での実用を目的としたユーティリティおよび資産裏付けコミュニティトークンであり、金融投資や従来型有価証券には該当しません。",
  "footer.about": "会社概要",
  "footer.contact": "お問い合わせ",
  "footer.legal": "法的情報",
  "footer.rights": "All rights reserved.",

  // Milestones
  "milestones.eyebrow": "直近ロードマップ:ブロックチェーンと物理インフラの橋渡し",
  "milestones.p1.title": "SFN セントラルキッチン・ハブ(カオヨイ)",
  "milestones.p1.desc":
    "機関投資家資本で資金調達される自動化中央加工施設が、一括食材調達、ソーラー冷蔵、ゼロウェイスト調理を担当。中間コストを排除し、配送前に価格安定を保証します。",
  "milestones.p1.target": "100% ソーラー駆動サプライチェーンの相互接続。",
  "milestones.p2.title": "スマート・エクスプレス店舗の超拡大",
  "milestones.p2.desc":
    "実証済みガストロノミー・フレームワークを初期拠点から主要高流量回廊に沿った高効率エクスプレス食堂の地域ネットワークへ拡張。各店は補助されたゼロコストエネルギーグリッドで稼働。",
  "milestones.p2.target": "複数拠点による地域サンドボックス展開。",

  // VillagePando additions (Phase A)
  "vp.swap.pegged.badge": "1:1 USDC 裏付けバウチャー",
  "vp.swap.pegged.tooltip":
    "各 VillagePando バウチャーは 1 USDC の準備で 1:1 に裏付けられ、いつでも額面で償還可能です。",
  "vp.swap.tax.eyebrow": "5% ソーラータックス",
  "vp.swap.tax.title": "この 5% はどこへ?",
  "vp.swap.tax.intro":
    "各取引から自動控除される 5% は、検証可能な公共インフラへ 100% ルーティングされます——プロジェクトの利益にはなりません。",
  "vp.swap.tax.total": "合計税額",
  "vp.swap.tax.perTx": "1 取引あたり",
  "vp.swap.tax.hardware.label": "ソーラーハードウェア基金",
  "vp.swap.tax.hardware.detail":
    "提携キッチンおよび村ノード向けのオフグリッド太陽光パネル、インバーター、蓄電装置を調達。",
  "vp.swap.tax.reforestation.label": "再植林と土地",
  "vp.swap.tax.reforestation.detail":
    "登録された区画で在来種の植樹と土壌再生を資金化し、その痕跡をオンチェーンに記録。",
  "vp.swap.tax.ops.label": "運用とコンプライアンス",
  "vp.swap.tax.ops.detail":
    "ハードウェア維持、設置員トレーニング、複数管轄のコンプライアンスコストをカバー。",
  "vp.nexus.trio.eyebrow": "// パンドー・トリオ · サーキュラー・フロー",
  "vp.nexus.trio.caption":
    "土地が水を育て、水がエネルギーを育て、エネルギーが食事を買い戻し、食事が村を支える。",
  "vp.nexus.trio.step1": "土地 → 水",
  "vp.nexus.trio.step2": "水 → エネルギー",
  "vp.nexus.trio.step3": "エネルギー → 食事バイバック",
  "vp.nexus.trio.step4": "食事 → 村",
  "nav.tokenomics": "トークノミクス",
  "nav.roadmap": "ロードマップ",
  "nav.vision": "ビジョン",
  "nav.whitepaper": "ホワイトペーパー",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "決済の透明性",
  "treasury.title": "MEAL2・MEAL4 の購入はすべて単一のトレジャリーへ",
  "treasury.desc": "購入が DEX や中継ウォレットを経由することはありません。完全な送金先アドレスはホバーで表示され、ボタン解放前にオンチェーンで検証されます。",
  "treasury.label": "プロジェクト・トレジャリー",
  "treasury.network": "ネットワーク",
  "treasury.copy": "アドレスをコピー",
  "treasury.copied": "コピーしました",
  "treasury.explorer": "エクスプローラーで表示",
  "treasury.status.checking": "送金先を検証中",
  "treasury.status.verified": "送金先を検証済み",
  "treasury.status.degraded": "アドレス有効 · ネットワーク混雑",
  "treasury.status.invalid": "送金先が未検証 — 購入は無効です",
  "receipt.eyebrow": "取引が確定しました",
  "receipt.title": "購入確認",
  "receipt.desc": "拠出は SFN プロジェクト・トレジャリーへ送られました。以下の署名を決済の控えとして保管してください。",
  "receipt.amount": "支払額",
  "receipt.received": "受取額",
  "receipt.destination": "トレジャリー送金先",
  "receipt.network": "ネットワーク",
  "receipt.hash": "トランザクション署名",
  "receipt.viewExplorer": "エクスプローラーで取引を表示",
  "receipt.close": "確認を閉じる",
  "receipt.copyHash": "ハッシュをコピー",
  "receipt.hashCopied": "ハッシュをコピーしました",
  "receipt.download": "JSON をダウンロード",
  "rpc.checking": "ネットワーク宛先を検証中…",
  "rpc.degraded": "ネットワーク混雑 — アドレスは有効、オンチェーン確認は再試行中",
  "rpc.invalid": "宛先が未検証 — 購入は無効です",

  // Analytics consent
  "consent.title": "アナリティクスの同意",
  "consent.desc": "本ページ改善のため、匿名かつCookie不要の解析（IP・フィンガープリントなし）を利用します。同意されるまでデータは送信されません。",
  "consent.accept": "同意する",
  "consent.decline": "拒否する",
  "meal2.tab.web3": "デジタルスワップ（Web3）",
  "hero.title": "食の価格を凍結する：健康的な一食を $1 で、永久に。",
  "hero.sub": "シンプルなユーティリティ。実在するインフラ。Meal2 と Meal4 が支えます。",
  "hero.badge": "世界初のデュアルトークン食料インフラ ——「$1 の一食」で食品インフレをヘッジします。",
  "hero.cta": "Meal2 を購入（$1 の食事）",
  "hero.ghost": "Meal4 を取得（ガバナンス）",
  "keep.title": "$1 の食事を維持する仕組み",
  "keep.sub": "3 つの実物資産がコスト圧力を吸収し、一皿の価格を動かしません。",
  "keep.solar.title": "太陽光エネルギー",
  "keep.solar.text": "オフグリッド太陽光が各キッチンを稼働させ、電気代を食事コストから取り除きます。",
  "keep.agri.title": "農業",
  "keep.agri.text": "農家からの直接調達と再植林が、仲介者なしで食材コストを固定します。",
  "keep.water.title": "清潔な水",
  "keep.water.text": "ろ過貯水槽が乾季でも日々の生産を支え、変動費をゼロに保ちます。",
  "brand.tagline": "$1 フードエンジン",
  "nav.product": "プロダクト",
  "nav.pilot": "パイロットキッチン",
  "trustpilot.eyebrow": "実証実験 · パイロット地域",
  "trustpilot.title": "タイで実証 — 世界へ拡大。",
  "trustpilot.desc": "アンカーキッチンとコミュニティハブはすでに稼働中です。ここで紹介する仕組みはすべて、実際の食事・生産者・地域で検証してからスケールします。",
  "trustpilot.b1": "アンカーキッチンが毎日稼働",
  "trustpilot.b2": "地域の生産者ネットワーク",
  "trustpilot.b3": "太陽光発電のコミュニティハブ",
  "trustpilot.b4": "オンチェーン決済が稼働中",
  "swap.quote.title": "ライブルート見積もり",
  "swap.quote.slippage": "最大スリッページ",
  "swap.quote.expiry": "見積もり有効期限",
  "swap.quote.minReceive": "最低受取量",
  "swap.quote.usdValue": "推定価値",
  "swap.quote.expiresIn": "{s}秒後に更新",
  "swap.quote.expired": "見積もりの有効期限切れ — 更新してください",
  "swap.quote.refresh": "見積もりを更新",
  "swap.quote.expiredError": "見積もりの有効期限が切れました。レートを更新して再試行してください。",
  "swap.quote.slippageError": "SOLレートがスリッページ上限を超えました。署名は行われていません。",
  "verify.badge": "購入証明",
  "verify.title": "レシートを検証",
  "verify.intro": "Solanaのトランザクション署名を貼り付けると、ネットワークとSFN台帳に対して購入を直接検証できます。検証はサーバー側で実行され、ウォレット接続は不要です。",
  "verify.modalIntro": "サーバー検証済みのオンチェーン状態と該当する台帳エントリ。",
  "verify.label": "トランザクション署名",
  "verify.placeholder": "Solanaのトランザクション署名を貼り付け",
  "verify.submit": "レシートを検証",
  "verify.busy": "検証中…",
  "verify.close": "レシート検証を閉じる",
  "verify.verified": "オンチェーンで検証済み",
  "verify.unreachable": "ネットワークに到達できません — 少し後で再試行",
  "verify.notConfirmed": "未確認",
  "verify.invalid": "有効なSolana署名ではありません。",
  "verify.rateLimited": "検索が多すぎます。1分ほど待って再試行してください。",
  "verify.replay": "このセッションで既に確認済みの署名です。",
  "verify.error": "検証サービスが混雑しています。少し後に再試行してください。",
  "verify.receiptId": "レシートID",
  "verify.signature": "署名",
  "verify.ledgerEntry": "台帳エントリ",
  "verify.purchase": "購入",
  "verify.value": "価値",
  "verify.wallet": "ウォレット",
  "verify.checks": "決済チェック",
  "verify.noLedger": "この署名に一致するSFN台帳エントリはまだありません。支払い直後の場合は数秒待って再確認してください。",
  "verify.explorer": "Solscanで見る",
  "admin.csv.export": "CSVをダウンロード",
  "admin.csv.exportLabel": "売上台帳をCSVファイルでダウンロード",
  "dexRoadmap.title": "流動性とインデックス掲載のロードマップ",
  "dexRoadmap.phase1": "プレセールとユーティリティ開始",
  "dexRoadmap.phase2": "Jupiter ストリクトリストと Raydium 流動性プール",
  "dexRoadmap.phase3": "CoinGecko と CoinMarketCap への掲載",
  "dexRoadmap.active": "進行中",
  "dexRoadmap.status.active": "進行中",
  "dexRoadmap.status.next": "次のフェーズ",
  "dexRoadmap.status.planned": "予定",
  "dexRoadmap.statusLive": "ロードマップの進捗状況はリアルタイムです。",
  "dexRoadmap.statusFallback": "リアルタイム状況を取得できません — 公開済みの計画を表示しています。",
  "dexRoadmap.visit": "{name} を新しいタブで開く",
  "swap.quote.refreshing": "レートを更新中…",
};
